export default {
	tenantId: "apex",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "apex"
	}
}
